
import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { SltMasterEndpoints } from '../end-points/slt-master.class';
const sltRateRequest = '/slt/api/rate/request/secure/jas/';

@Injectable({
  providedIn: 'root'
})

export class FindLocationRestService {
  private http = inject(HttpClient);
  locationId = 0;

  getOrderLocationsByName(searchTerm: string, locaRoleType?: string, businessSegmentId?: number): Observable<HttpResponseBase> {
    let params = new HttpParams().set('searchTerm', searchTerm);
    if (locaRoleType !== undefined) {
      params = params.set('locaRoleType', locaRoleType);
    }
    if (businessSegmentId !== undefined) {
      params = params.set('businessSegmentId', businessSegmentId.toString());
    }
    return this.http.get<HttpResponseBase>(`${SltMasterEndpoints.findLocations}`, { params });
  }

  public getPickupAndDeliveryLocations(searchText) {
    return this.http.get<HttpResponseBase>(`${SltMasterEndpoints.getPickDropDeliveryLocation}?searchTerm=${searchText}`);
  }

  getDrayCarrierLocations(searchTerm: string, busSegmId: any): Observable<HttpResponseBase> {
    const locationSearch = {
      searchTerm: searchTerm,
      busSegmId: busSegmId

    }
    return this.http.post<HttpResponseBase>(`${SltMasterEndpoints.FIND_DRAY_CARRIER_LOOKUP}`, locationSearch);
  }

   getRailRoute(searchTerm: string): Observable<HttpResponseBase> {
    return this.http.get<HttpResponseBase>(`${sltRateRequest}analysis/get-rail-carriers-with-routes?name=${searchTerm}`);
  }

  getRailRouteJunction(searchTerm: string, name: string): Observable<HttpResponseBase> {
    return this.http.get<HttpResponseBase>(`${sltRateRequest}analysis/get-rail-junctions-by-rail-route?nameLike=${name}&route=${searchTerm.toUpperCase()}`);
  }


  getCarloadVendorLocations(searchTerm: string): Observable<HttpResponseBase> {
    const locationSearch = {
      searchTerm: searchTerm,
    };
    return this.http.post<HttpResponseBase>(`${SltMasterEndpoints.FIND_CARLOAD_VENDOR_LOOKUP}`, locationSearch);
  }

  public getCommodityNewLookupPublicProgram(searchText, searchTerm?) {
    return this.http.get<HttpResponseBase>(`${SltMasterEndpoints.findLocations}?searchTerm=${searchText}&locaRoleType=${searchTerm ? searchTerm : searchText}`);
  }

  getExternalLocations(searchTerm: string, locationType: string): Observable<HttpResponseBase> {
    const locationSearch = {
      query: searchTerm,
      locationType: locationType
    };
    return this.http.post<HttpResponseBase>(`${SltMasterEndpoints.FIND_CITY_STATE_COUNTRY_EXTERNAL}`, locationSearch);
  }
}
